import { useState } from 'react';
import { Link } from 'react-router-dom';
import MediaCard from '@/components/feature/MediaCard';
import { getLatestMedia } from '@/utils/media';

export default function LatestSection() {
  const [tab, setTab] = useState<'all' | 'movie' | 'tv'>('all');
  const items = getLatestMedia(6, tab === 'all' ? undefined : tab);

  const tabs: { key: 'all' | 'movie' | 'tv'; label: string }[] = [
    { key: 'all', label: '全部' },
    { key: 'movie', label: '最新电影' },
    { key: 'tv', label: '最新剧集' },
  ];

  return (
    <section className="animate-fade-up">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-600">
            <i className="ri-time-line text-lg"></i>
          </span>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">最新上线</h2>
        </div>
        <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
          {tabs.map((t) => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                tab === t.key ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4">
        {items.map((item) => (
          <MediaCard key={item.id} item={item} />
        ))}
      </div>
      <div className="mt-5 flex justify-center">
        <Link
          to={tab === 'tv' ? '/category/tv' : '/category/movie'}
          className="flex items-center gap-1 whitespace-nowrap rounded-full border border-primary-300 bg-primary-50 px-5 py-2 text-sm font-medium text-primary-700 hover:bg-primary-100"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}